.cartItem {
	max-width: 100% !important;
	min-width: 100% !important;
	margin-top: 0px !important;
	margin-bottom: 15px !important;
	padding: 20px !important;
}

.boldFont {
	font-weight: bold !important;
}

.iButton {
	border-radius: 50% !important;
	background-color: var(--light-gray) !important;
}

.marginLeft {
	margin-left: 12px !important;
}
